// import './App.css';
// import UserForm from './Form';

// function App() {
//   return (
//     <div className="App">
//       <UserForm />
//     </div>
//   );
// }

// export default App;

import { createBrowserRouter } from "react-router-dom";
import "./App.css";
import UserForm from "./Form";
import AdminDashboard from "./Admin/dashboard";
import AdminLayout from "./Admin/Drawer";
import DataTable from "./Admin/Settings";
import UserList from "./Admin/userList";
import Redownload from "./Admin/Redownload";
import VipForm from "./VipForm";
import VipUsers from "./Admin/VipEvents";
import VipEvents from "./Admin/VipEvents";
import ScannerList from "./Admin/Scanner";
import VIPScanner from "./Admin/VIPScanner";
import UniqueGatepass from "./UniqueGate";
import UniqueEvents from "./Admin/UniqueEvents";
import NewUserList from "./Admin/NewUserList";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <div className="App">
        <UserForm />
      </div>
    ),
  },
  {
    path: "/:id",
    element: (
      <div className="App">
        <UserForm />
      </div>
    ),
  },
  {
    path: "/unique/gate/23-12-24/:id",
    element: (
      <div className="App">
        <UniqueGatepass />
      </div>
    ),
  },
  {
    path: "/unique/settings",
    element: (
      <div className="App">
        <UniqueEvents />
      </div>
    ),
  },

  {
    path: "/vip/parking",
    element: (
      <div className="App">
        <VipForm />
      </div>
    ),
  },
  {
    path: "/scanner",
    element: (
      <div className="App">
        <ScannerList />
      </div>
    ),
  },
  {
    path: "/vip/camera/scanner",
    element: (
      <div className="App">
        <VIPScanner />
      </div>
    ),
  },
  {
    path: "/vipEvents",
    element: (
      // <AdminLayout>
      <div className="App">
        <VipEvents />
      </div>
      // </AdminLayout>
    ),
  },
  {
    path: "/admin/dash",
    element: (
      <AdminLayout>
        <div className="App">
          <AdminDashboard />
        </div>
      </AdminLayout>
    ),
  },
  {
    path: "/settings",
    element: (
      // <AdminLayout>
      <div className="App">
        <DataTable />
      </div>
      // </AdminLayout>
    ),
  },
  {
    path: "/userList",
    element: (
      <div className="App">
        <UserList />
      </div>
    ),
  },
  {
    path: "/unique/userList",
    element: (
      <div className="App">
        <NewUserList />
      </div>
    ),
  },
  {
    path: "/redownload",
    element: (
      <div className="App">
        <Redownload />
      </div>
    ),
  },
]);

export default router;
